export default {"src":"/_next/static/media/verified.7acdba11.svg","height":66,"width":66};